//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { MessageMethod } from './Enums';

export class SentMessageSearchOptions extends ItemBase {
    StartDate: string | null = null;
    EndDate: string | null = null;
    SearchText: string | null = null;
    AlsoApplySearchTextToMessageBody: boolean = false;
    FamilyID: string | null = null;
    MessageMethods: MessageMethod[] = [];

    constructor(initializer?: Partial<SentMessageSearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "SentMessageSearchOptions";
}
